import React, {useState, useEffect} from "react";

import WeatherForecastDay from "./WeatherForecastDay";
import "./WeatherForecast.css";
import axios from "axios";
export default function WeatherForecast(props){
    let [loaded, setLoaded]= useState(false);
    let [forecast, setForecast]= useState(null);
    useEffect(()=>{
        setLoaded(false);
    }, [props.coordinates]);
    function handleResponse(response){
        console.log(response.data);
        setForecast(response.data.daily);
        setLoaded(true);
    }
    function load(){
        let apiKey= "6a3c54ed0f54ba33o91e65bbf9bt60ae"
console.log(props.coordinates.longitude);
    let longitude=props.coordinates.longitude;
    let latitude=props.coordinates.latitude;
    let apiUrl=`https://api.shecodes.io/weather/v1/forecast?lat=${latitude}&lon=${longitude}&key=${apiKey}&units=metric`
    axios.get(apiUrl).then(handleResponse);

    }
    if (loaded){
        return (
        <div className="WeatherForecast"><div className="row">
            
            {forecast.map(function(dailyForecast,index){
                if (index<5){
                return(
                <div className="col" key={index}>
            <WeatherForecastDay data={dailyForecast} />
            
            </div>)}
            else{
                return null;
            }
            })}
        </div></div>)
    
    
}
else{  
load();
    return null;
}}